module.exports = __webpack_public_path__ + "static/media/lili.ccb26fcc.jpeg";